import { render, staticRenderFns } from "./FirmThumb.vue?vue&type=template&id=00a15066&scoped=true&"
import script from "./FirmThumb.vue?vue&type=script&lang=js&"
export * from "./FirmThumb.vue?vue&type=script&lang=js&"
import style0 from "./FirmThumb.vue?vue&type=style&index=0&id=00a15066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a15066",
  null
  
)

export default component.exports